import { component } from 'picoapp';

export default component(async (node) => {
  const initSlider = async () => {
    const sliderElement = node.querySelector<HTMLElement>('[data-carousel]');
    const progress = node.querySelector('[data-progress]');

    const Swiper = (await import(
      /* webpackChunkName: "swiper" */
      'modules/swiper'
    )).default;

    const swiperSlider = new Swiper(sliderElement, {
      slidesPerView: 1,
      loop: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    if (progress) {
      swiperSlider.on('slideChange', (swiper) => {
        progress.textContent = (swiper.realIndex + 1).toString();
      });
    }

    swiperSlider.init();
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(async (entry) => {
      if (entry.isIntersecting) {
        initSlider();
        observer.disconnect();
      }
    });
  });

  observer.observe(node);
});
